import { render } from "./WorkspaceDialog.vue?vue&type=template&id=3bb3a5de&scoped=true"
import script from "./WorkspaceDialog.vue?vue&type=script&lang=js"
export * from "./WorkspaceDialog.vue?vue&type=script&lang=js"

import "./WorkspaceDialog.vue?vue&type=style&index=0&id=3bb3a5de&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb3a5de"]])

export default __exports__